var _defs, _rect, _circle, _circle2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadgen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: 800,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1B1035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3B0764"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#g)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 80,
    r: 90,
    fill: "#854CE6",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 380,
    r: 70,
    fill: "#22D3EE",
    opacity: 0.18
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 200,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 42,
    fontWeight: 700,
    fill: "#F8FAFC"
  }, "LeadGen")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 250,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#C4B5FD"
  }, "AI Lead Finder Agent")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 310,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fill: "#94A3B8"
  }, "Python \uFFFD Groq LLM \uFFFD Streamlit \uFFFD Playwright")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadgen);
export default __webpack_public_path__ + "static/media/leadgen.d28897d8aa2a062c115ac896bd381793.svg";
export { ForwardRef as ReactComponent };